import axios from "axios";
import NProgress from "nprogress";
import { StatusCodes } from "http-status-codes";
import router from "../router";
import store from "../store";

const config = {
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    //"Access-Control-Allow-Origin": process.env.ORIGIN,
  },
  timeout: 3 * 60 * 1000,
  withCredentials: true,
};

const apiClient = axios.create(config);

// Start progress bar before a request is made
apiClient.interceptors.request.use((config) => {
  NProgress.start();
  return config;
});

apiClient.interceptors.response.use(
  (response) => {
    NProgress.done();
    return response;
  },
  (error) => {
    NProgress.done();

    const isProtectedPage =
      router.currentRoute.value.meta.requiresAuth === true;

    if (
      error.response &&
      error.response.status === StatusCodes.UNAUTHORIZED &&
      isProtectedPage
    ) {
      // Log user out, then send user to log in screen
      store.dispatch("auth/signOut");
      router.go({
        path: "/",
        force: true,
      });
    } else {
      return Promise.reject(error);
    }
  }
);

export { apiClient };
